module.exports = __webpack_public_path__ + "img/thumbnail1.a84a7936.png";